module.exports = __webpack_public_path__ + "img/地图综合应用.b33261c2.svg";